<template>
  <div>
    <div
      class="instruction_title text-left para-mrgn-20"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedTitle`,
        val: lang,
        html: question.formattedTitle
      }"
      v-html="question.formattedTitle"
    />
    <div
      class="text-left pt-6 pl-2 pr-2"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedInformation`,
        val: lang,
        html: question.formattedInformation
      }"
      v-html="question.formattedInformation"
    />
    <div class="row p-0 m-0">
      <img width="100%" height="210px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley wong-baker-img d-block text-center" alt="hurts-worse.svg" />
      <div @click.once="$emit('onClick', question)" class="text-center mx-auto mt-32 wong-baker-count-box">
        <input type="number" class="wong-baker-count d-block mx-auto " v-model="answerScoreWongBaker" onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57" @change="numberInput" placeholder="" />
      </div>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "wong-baker",
  mixins: [langTranslate],
  data() {
    return {
      selectedImg: null,
      hasFieldError: false,
      fieldErrorText: "",
      scoresMap: {},
      faces: [
        {
          greyImg: "static/img/activity-configurator/no-hurt-grey.svg",
          blueImg: "static/img/activity-configurator/no-hurt.svg",
          score: 0,
          text: "No Hurt"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-little-bit-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-little-bit.svg",
          score: 2,
          text: "Hurts Little Bit"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-little-more-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-little-more.svg",
          score: 4,
          text: "Hurts Little More"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-even-bit-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-even-bit.svg",
          score: 6,
          text: "Hurts Even bit"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-whole-lot-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-whole-lot.svg",
          score: 8,
          text: "Hurts Whole Lot"
        },
        {
          greyImg: "static/img/activity-configurator/hurts-worse-grey.svg",
          blueImg: "static/img/activity-configurator/hurts-worse.svg",
          score: 10,
          text: "Hurts Worse"
        }
      ],
      answerScoreWongBaker: null
    };
  },
  mounted() {
    if (this.question && this.question.answer) {
      this.answerScoreWongBaker = this.question.answer;
    }
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  methods: {
    numberInput() {
      this.question.answer = this.answerScoreWongBaker;
    },
    switchImage(i) {
      this.selectedImg = i.score;
      this.question.answer = i.score;
    },
    onAnswerChange(e) {
      this.$nextTick(() => {
        this.onChangeOptions(e);
        this.$emit("onAnswerChange", this.question);
      });
    },
    onChangeOptions(e) {
      this.componentData.computedScore = this.scoresMap[e];
      this.componentData.actualScore = this.scoresMap[e];
    },
    clearAnswer(){
      this.question.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
.wong-baker-img {
  width: 100%;
  height: 210px;
}
.wong-baker-count {
  width: 60px;
  height: 59px;
  padding: 19px 16px;
  text-align: center;
  border-radius: 8px;
  border: solid 1px #b0bac9;
  font-size: 24px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #666669;
}
.wong-baker-count-box input[type="number"]::placeholder {
  font-size: 22px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
</style>
